import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { fpColors } from '../styles/theme';

interface CheckboxProps {
  value: boolean;
  onValueChange: (v: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  value,
  onValueChange,
  label,
  disabled = false,
}) => {
  return (
    <Pressable
      onPress={() => !disabled && onValueChange(!value)}
      disabled={disabled}
      style={({ pressed }) => [
        styles.row,
        pressed && !disabled && styles.rowPressed,
        disabled && styles.disabled,
      ]}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: value, disabled }}
    >
      <View style={[styles.box, value && styles.boxChecked]}>
        {value && (
          <MaterialIcons name="check" size={16} color={fpColors.onPrimary} />
        )}
      </View>
      {label && <Text style={styles.label}>{label}</Text>}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  rowPressed: {
    opacity: 0.7,
  },
  disabled: {
    opacity: 0.5,
  },
  box: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 1.5,
    borderColor: fpColors.outlineVariant,
    backgroundColor: fpColors.surfaceContainerLowest,
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxChecked: {
    backgroundColor: fpColors.primary,
    borderColor: fpColors.primary,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: fpColors.onSurfaceVariant,
  },
});
